import { MessageTransport } from './type';

export default class MessagePortTransport<IncomingMessage, OutgoingMessage>
  implements MessageTransport<IncomingMessage, OutgoingMessage>
{
  constructor(
    public sessionId: string,
    public port: MessagePort,
    public onMessage: (incomingMessage: IncomingMessage) => void,
    public closeMessageTransport: () => void,
  ) {
    this.port.onmessage = this.onPortMessage.bind(this);
    this.port.start();
  }

  close() {
    this.closeMessageTransport();
    this.port.close();
  }

  sendMessage(outgoingMessage: OutgoingMessage) {
    this.port.postMessage(JSON.stringify(outgoingMessage));
  }

  onPortMessage(event: MessageEvent<string>) {
    const deserialized = JSON.parse(event.data) as IncomingMessage;
    this.onMessage(deserialized);
  }
}
